export const SANCTION_SOURCES = {
  unsc: 'Sanções Nações Unidas (CSNU)',
  govuk: 'Sanções financeiras Reino Unido',
  eu: 'Sanções União Europeia',
  ofac: 'Indivíduos na lista de SDN da OFAC',
  'cvm - suspension alert': 'CVM - Alerta de Suspensão',
  'cvm - penalidade temporaria': 'CVM - Penalidade Temporaria',
  'cvm - term of commitment': 'CVM - Termo de Compromisso',
  'central bank': 'Banco Central - Inabilitado',
  'embargos do ibama': 'Embargos do Ibama',
  fbi: 'FBI',
  interpol: 'INTERPOL',
  ceaf: 'CEAF',
  cnep: 'CNEP',
  mte: 'MTE (Trabalho Análogo ao de Escravo)',
  ncj: 'Conselho Nacional de Justiça',
  ceis: 'CEIS',
  cepim: 'CEPIM',
  'dishonest tcu': 'Inelegível ou Inidôneo - TCU (Tribunal de Contas da União)',
  'leniency agreements': 'Acordos de Leniência (Controladoria-Geral da União)',
  'bsm supervision': 'Processo Administrativo Disciplinar (Supervisão BSM)',
  'banned from bidding and contracting a bank': 'Impedido de Licitar e Contratar com Banco',
  'são paulo state court of auditors': 'Tribunal de Contas do Estado de São Paulo',
  'seape-df': 'SEAPE-DF',
  'canada sanctions': 'Sanções do Canadá',
  ddtc: 'Diretoria de Controles de Comércio de Defesa (DDTC)',
}
